import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import i18n from 'i18next';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Typography from '@material-ui/core/Typography';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';

import { system800 } from 'Mui/styles/color';

export default function DialogParticipantPrizeEmpty({ title, desc, isOpen, onCloseHandler }) {
    return (
        <Modal
            css={modalStyle}
            open={isOpen}
            onClick={onCloseHandler}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500
            }}
            onClose={(event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onCloseHandler();
                }
            }}
        >
            <Fade in={isOpen}>
                <div css={containerStyle}>
                    <Typography css={titleStyle}>{title}</Typography>
                    <Typography css={descriptionStyle}>{desc}</Typography>
                    <div css={actionButtonContainerStyle}>
                        <Button variant="contained" css={buttonStyle}>
                            {i18n.t('btn.ok')}
                        </Button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

DialogParticipantPrizeEmpty.propTypes = {
    title: PropTypes.string,
    desc: PropTypes.string,
    isOpen: PropTypes.bool,
    onCloseHandler: PropTypes.func,
    onRecopyHandler: PropTypes.func,
    loading: PropTypes.bool
};

const modalStyle = css`
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.56);
    backdrop-filter: blur(10.8731px);
`;

const containerStyle = css`
    width: 100%;
    max-width: 343px;
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 12px;
    background-color: #ffffff;
    outline: none;
`;

const titleStyle = css`
    margin: 6px auto;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    color: ${system800.color};
`;

const descriptionStyle = css`
    min-height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: ${system800.color};
`;

const actionButtonContainerStyle = css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 12px;
    padding-bottom: 4px;
`;

const buttonStyle = css`
    width: 144px;
    height: 48px;
    background: #02a0fc;
    border-radius: 50px;
    color: #ffffff;
`;
